// example
export const systemName = state => state.common.systemName
export const userInfo = state => state.common.userInfo
export const currentWeekly = state => state.weekly.currentWeekly
export const weeklyList = state => state.weekly.weeklyList
export const departmentWeeklyList = state => state.weekly.departmentWeeklyList



// WEBPACK FOOTER //
// ./src/vuex/getters.js